import {
  FilterLegacy,
  InputFieldConfig,
  DerivedEventFilterLegacy,
  DerivedEventLegacy,
  DerivedEventTypeLegacy,
  DerivedEventFilterType,
  type ActiveCohortBuilderItemLegacy,
  SimpleEventLegacy,
} from '@verantos-dev/types-cohorts';

import { buildConfigMapDerivedEvents, buildConfigMapDerivedEventFilters } from './buildConfigMap';
import { DERIVED_EVENT_FILTER_MAPPING } from './filterTypes';
import { mutateInputFieldsDerivedEvents } from './inputFieldUtils';
import { getNewEventsForType } from '../../utils/getNewEventsForType';

export const addOrMutateDerivedFilters = (
  derivedEvent: ActiveCohortBuilderItemLegacy
): {
  eventFilters: DerivedEventFilterLegacy[];
  uniquenessFilters: FilterLegacy[] | undefined;
  temporalConstraints: FilterLegacy[];
} => {
  const { eventFilters, uniquenessFilters, temporalConstraints } = derivedEvent;

  if (eventFilters.length === 0) {
    getNewEventsForType(derivedEvent.type as DerivedEventTypeLegacy).forEach((event) => {
      eventFilters.push(event);
    });
  }

  const filterPairs = [
    [uniquenessFilters, DerivedEventFilterType.UNIQUENESS],
    [temporalConstraints, DerivedEventFilterType.TEMPORAL],
  ] as const;

  filterPairs.forEach(([filters, filterType]) => {
    filters?.forEach((filter) => {
      if (filter.inputFields.length === 0) {
        mutateInputFieldsDerivedEvents(filter, filterType);
      }
    });
  });

  return { eventFilters, uniquenessFilters, temporalConstraints };
};

export const reduceDerivedConfigMap = (
  acc: Record<string, InputFieldConfig>,
  key: string,
  {
    derivedEvent,
    eventFilters,
    simpleEvents,
    derivedEvents,
    eventFilterNames,
  }: {
    derivedEvent: ActiveCohortBuilderItemLegacy;
    eventFilters: DerivedEventFilterLegacy[];
    simpleEvents: SimpleEventLegacy[];
    derivedEvents: DerivedEventLegacy[];
    eventFilterNames: string[];
  }
): Record<string, InputFieldConfig> => {
  if (key === 'eventFilters') {
    eventFilters.forEach((ef) => {
      const configMap = buildConfigMapDerivedEvents(
        derivedEvent,
        ef as DerivedEventFilterLegacy,
        simpleEvents,
        derivedEvents,
        eventFilterNames
      );
      Object.assign(acc, configMap);
    });
  } else if (key === 'uniquenessFilters' || key === 'temporalConstraints') {
    derivedEvent[key]?.forEach((f) => {
      const configMap = buildConfigMapDerivedEventFilters(
        f as FilterLegacy,
        DERIVED_EVENT_FILTER_MAPPING[key]
      );
      Object.assign(acc, configMap);
    });
  }
  return acc;
};
